import { render, staticRenderFns } from "./FieldWords.vue?vue&type=template&id=f153176e"
import script from "./FieldWords.vue?vue&type=script&lang=js"
export * from "./FieldWords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports